import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=4eb6178c"
import script from "./billing.vue?vue&type=script&lang=js"
export * from "./billing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb6178c')) {
      api.createRecord('4eb6178c', component.options)
    } else {
      api.reload('4eb6178c', component.options)
    }
    module.hot.accept("./billing.vue?vue&type=template&id=4eb6178c", function () {
      api.rerender('4eb6178c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/settings/billing.vue"
export default component.exports